/**
 * Canonical EffectAtom / RewardAtom id lists (no Zod).
 * Used by data schemas and repo tooling (e.g. validate-specs).
 */

export const EFFECT_ATOMS = [
  'damage',
  'fixedDamage',
  'statusChance',
  'statStage',
  'heal',
  'drain',
  'recoil',
  'multiHit',
  'flinchChance',
  'weather',
  'screen',
  'protect',
  'priority',
  'chargeSelf',
  'chargeAlly',
  'uniqueSignatureCondition',
] as const;

export const REWARD_ATOMS = [
  'giveCurrency',
  'giveItem',
  'givePokeball',
  'healTeam',
  'learnMoveBypassPool',
  'revealMoveFromPool',
  'unlockShopRoster',
  'applyTempBuff',
  'triggerMystery',
  'grantCandy',
  'grantXp',
] as const;
